/**
 * Shared Auth0 authorizationParams for Business Users (org-required) clients.
 * Set REACT_APP_AUTH0_ORGANIZATION per environment (staging and production use
 * separate Auth0 applications and organizations — never cross-wire).
 */

const DEFAULT_AUDIENCE = 'https://api.krosskast.com';
const DEFAULT_SCOPE = 'openid email profile offline_access';

export const getAuth0Audience = (): string =>
  process.env.REACT_APP_AUTH0_AUDIENCE || DEFAULT_AUDIENCE;

export const getAuth0Organization = (): string | undefined => {
  const org = (process.env.REACT_APP_AUTH0_ORGANIZATION || '').trim();
  return org.length > 0 ? org : undefined;
};

export type Auth0AuthorizationParamsOptions = {
  audience?: string;
  scope?: string;
  redirect_uri?: string;
};

/**
 * Builds authorizationParams for Auth0Provider, loginWithRedirect, and getAccessTokenSilently.
 * Includes `organization` when REACT_APP_AUTH0_ORGANIZATION is set (required for Business Users apps).
 */
export const buildAuth0AuthorizationParams = (
  options: Auth0AuthorizationParamsOptions = {},
): Record<string, string> => {
  const params: Record<string, string> = {
    audience: options.audience ?? getAuth0Audience(),
    scope: options.scope ?? DEFAULT_SCOPE,
  };

  if (options.redirect_uri) {
    params.redirect_uri = options.redirect_uri;
  }

  const organization = getAuth0Organization();
  if (organization) {
    params.organization = organization;
  }

  return params;
};
